module.exports = __webpack_public_path__ + "img/participant-picture-2.fc270aa.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/participant-picture-2.svg
// module id = iXgU
// module chunks = 0